import React from 'react';

import BasePane from '@totem/components/BasePane';
import ReportsContainer from '@totem/components/reports/ReportsContainer';
import ReportsPanel from '@totem/components/reports/ReportsPanel';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const ReportPage = () => {
  return (
    <ReportsContainer>
      <ContentLayout pageTitle="Reports">
        <BasePane>
          <PrimaryContentPane>
            <ReportsPanel />
          </PrimaryContentPane>
        </BasePane>
      </ContentLayout>
    </ReportsContainer>
  );
};

export default ReportPage;
